import {SegmentedControl} from '@dropbox/dig-components/controls';
import {Tabs} from '@dropbox/dig-components/tabs';
import {getDefaultTeamsRoute, ROUTE_PATHS} from 'constant';
import {t} from 'i18next';
import {useNavigate} from 'react-router';

export type TeamsSection = 'teams' | 'components-and-services' | 'apps';

const SECTIONS: TeamsSection[] = ['teams', 'components-and-services', 'apps'];

const useSectionNavigation = () => {
  const navigate = useNavigate();
  const routesByTab: Record<TeamsSection, string> = {
    teams: getDefaultTeamsRoute(),
    'components-and-services': ROUTE_PATHS.TEAMS_COMPONENTS_AND_SERVICES,
    apps: ROUTE_PATHS.TEAMS_APPS,
  };
  return (section: TeamsSection) => navigate(routesByTab[section]);
};

const sectionLabel = (section: TeamsSection) =>
  section === 'teams'
    ? t('teams')
    : section === 'components-and-services'
      ? t('teams_components_and_services')
      : t('teams_apps');

/** Narrow screens' section tabs, at the top of the directory. */
export const TeamsSectionTabs = ({active}: {active: TeamsSection}) => {
  const goTo = useSectionNavigation();

  return (
    <Tabs selectedTab={active} onSelection={(tab) => goTo(tab as TeamsSection)}>
      <Tabs.Group hasHorizontalPadding={false}>
        {SECTIONS.map((section) => (
          <Tabs.Tab key={section} id={section}>
            {sectionLabel(section)}
          </Tabs.Tab>
        ))}
      </Tabs.Group>
    </Tabs>
  );
};

/** The page header's section switch, like Workstreams' Details / Metrics. */
export const TeamsSectionSwitch = ({active}: {active: TeamsSection}) => {
  const goTo = useSectionNavigation();

  return (
    <SegmentedControl
      selectedValue={active}
      onSelection={(value) => {
        if (value) goTo(value as TeamsSection);
      }}
    >
      {SECTIONS.map((section) => (
        <SegmentedControl.Option key={section} variant="text" value={section}>
          {sectionLabel(section)}
        </SegmentedControl.Option>
      ))}
    </SegmentedControl>
  );
};
